import React from "react";

export default function HelpCenterModal({ cancelModal }) {
  return (
    <>
      <div className="modal-backdrop show bcs-modal-backdrop"></div>

      <div
        className="modal show d-block"
        tabIndex="-1"
        role="dialog"
        aria-modal="true"
      >
        <div className="modal-dialog modal-dialog-centered bcs-modal-dialog">
          <div className="modal-content border-0 shadow bcs-modal-content">
            <div className="modal-header position-relative flex-column border-0 pb-2 bcs-modal-header">
              <button
                type="button"
                className="btn-close position-absolute top-0 end-0 m-3"
                onClick={cancelModal}
              ></button>

              <div className="text-center w-100 mt-2">
                <div className="bcs-help-icon-wrap">
                  <div className="bcs-help-icon">?</div>
                </div>

                <div className="bcs-title brand-dark-purple mt-3">
                  Help center
                </div>

                <div className="bcs-subtitle mt-2 px-2">
                  Our support team is here to help with any questions about your
                  account, bookings, or using Neurotherapy Directory.
                </div>
              </div>

              <div className="w-100 bcs-divider"></div>
            </div>

            <div className="modal-body pt-2 bcs-modal-body">
              <div className="bcs-help-card">
                <div className="bcs-help-label">Support email</div>

                <a
                  href="mailto:info@neurotherapydirectory.com"
                  className="bcs-help-email"
                >
                  info@neurotherapydirectory.com
                </a>

                <div className="bcs-help-copy mt-2">
                  Please include a short description of your issue so our team
                  can assist you more quickly.
                </div>
              </div>

              <div className="bcs-help-points mt-3">
                <div className="bcs-help-point">
                  <span className="bcs-help-point-dot"></span>
                  <span>Account support and login issues</span>
                </div>

                <div className="bcs-help-point">
                  <span className="bcs-help-point-dot"></span>
                  <span>Booking and profile related questions</span>
                </div>

                <div className="bcs-help-point">
                  <span className="bcs-help-point-dot"></span>
                  <span>General platform assistance</span>
                </div>
              </div>

              <div className="bcs-help-note mt-3">
                We aim to respond as soon as possible during normal business
                hours.
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}